import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {
  useCurrentArtistPermissions,
  CATALOG_VIEW,
} from '../../../features/artists';
import { useIsHomeEnabledForCurrentUser } from '../../../features/ArtistHome';

export function ArtistFallback() {
  const permissions = useCurrentArtistPermissions();

  if (useIsHomeEnabledForCurrentUser()) {
    // has viewer permission
    return (
      <Route
        path="/artist/:artistId"
        render={({ match }) => <Redirect to={`${match.url}/home`} />}
      />
    );
  }

  if (permissions.includes(CATALOG_VIEW)) {
    return (
      <Route
        path="/artist/:artistId"
        render={({ match }) => <Redirect to={`${match.url}/music`} />}
      />
    );
  }

  return <Redirect to="/" />;
}
